const routeTitle = {
	documentsList: 'Documents {sep} List',
	documentsGroup: 'Documents {sep} Group',
	roles: 'Roles',
	persons: 'Persons',
	documents: 'Documents',
	buildings: 'Buildings',
	units: 'Units',
	invoices: 'Invoices',
	meters: 'Meters',
	craftsmanTasks: 'Craftsman Tasks',
	tasks: 'Tasks',
	openRequests: 'Open Requests',
	reports: 'Reports',
	analysis: 'Analysis',
	notifications: 'Notifications',
	createTeammember: 'Create Team Member',
	updateTeammember: 'Update Team Member',
	documentTypes: 'Documents Types',
	notesTypes: 'Note Types',
	createNotesType: 'Create Note Type',
	updateNotesType: 'Update Note Type',
	definitions: 'Definitions',
	createHandovertemplate: 'Create Handover Protocol Template',
	updateHandovertemplate: 'Update Handover Protocol Template',
	createReportType: 'Create Report Type',
	updateReportType: 'Update Report Type',
	createReportStatus: 'Create Report Status',
	updateReportStatus: 'Update Report Status',
	createReporttypeSubcategory: 'Create subcategory',
	updateReporttypeSubcategory: 'Update subcategory',
	subscriptions: 'Subscriptions',
	buildingVisibility: 'Building Visibility',
	syncFailures: 'Sync Errors',
	accessRejections: 'Rejected Accesses',
	createFaqCategory: 'Create FAQ Category',
	editFaqCategory: 'Edit FAQ Category',
	createFaqEntry: 'Create FAQ Entry',
	editFaqEntry: 'Edit FAQ Entry',
	profileChangePassword: '@:component.profile.change_password',
	profileUpdateRequest: '@:component.profile.updateRequest.title',
	profileUploadPicture: 'Upload profile picture',
	profileAccount: '@:component.profile.name',
	profileMyAccounts: '@:component.profile.my_accounts',
}

export default routeTitle
